<template>
  <v-container fluid class="px-0">
    <v-row align="baseline" class="mb-3">
      <v-col cols="12" md="12">
        <el-button
          v-if="showIkeltiTurta"
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="ikeltiTurtas()"
          >Įkelti NT</el-button
        >
        <template v-if="showTurtasSearch">
          <el-button
            v-if="showPagalAdresa"
            primary
            small
            :loading="loading"
            :disabled="isSearching"
            @click.native="adresasTurtas()"
            >NT paieška pagal adresą</el-button
          >
          <el-button
            v-if="showPagalRegistra"
            primary
            small
            :loading="loading"
            :disabled="isSearching"
            @click.native="registrasTurtas()"
            >NT paieška pagal registrą</el-button
          >
          <el-button
            v-if="showPasalintiTurta"
            small
            :loading="loading"
            :disabled="isSearching"
            @click.native="pasalintiTurtas()"
            >Pašalinti įkeltus NT</el-button
          >
        </template>
      </v-col>
    </v-row>
    <v-row v-if="showFail" align="baseline" class="mb-0">
      <v-col cols="12">
        <v-alert dense outlined type="error">
          {{ failMsg }}
        </v-alert>
      </v-col>
    </v-row>
    <form
      v-if="showSearchForm && showTurtasSearch"
      @keydown.enter.prevent="searchTurtas()"
      @keydown.esc.prevent="cancelSearch()"
    >
      <v-row align="baseline" class="mb-0">
        <v-col cols="12" md="8">
          <el-text-field
            label="Unikalus numeris"
            :tooltip="`${ntrTooltipPrefix} Turtas. Unikalus numeris. Paieškai`"
            :readonly="isSearching"
            hide-details="auto"
            v-model="tur_identifikatorius"
          />
        </v-col>

        <v-col cols="12" md="4">
          <el-button
            primary
            @click.native="searchTurtas()"
            :loading="loading"
            :disabled="isSearching"
            >Ieškoti</el-button
          >
          <el-button
            @click.native="cancelSearch()"
            :loading="loading"
            :disabled="isSearching"
            >Išvalyti</el-button
          >
        </v-col>
      </v-row>
    </form>

    <modal-ntr-turtas-sarasas
      v-model="showTurtasSarasas"
      :is-adresas="turtasSarasasAdresas"
      :is-registras="turtasSarasasRegistras"
      :turtas-teise="turtasTeise"
      @updateTurtasList="updateTurtasList"
    />
    <modal-confirm
      :title="modalConfirmTitle"
      :text="modalConfirmText"
      :action="modalConfirmAction"
      v-model="showConfirm"
      @confirmIkeltiTurtas="confirmIkeltiTurtas"
      @cancelConfirm="closeConfirm"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import ModalNtrTurtasSarasas from '../modals/ModalNtrTurtasSarasas'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'RegPrasymasTurtasSearch',
  components: {
    ModalNtrTurtasSarasas,
    ModalConfirm,
  },
  mixins: [busena, tooltipNtr],
  props: {
    turtasTeise: { type: Boolean, default: false },
    turtasLength: { type: Number, default: 0 },
    pageloading: { type: Boolean, default: false },
  },
  data() {
    return {
      tur_identifikatorius: null,
      isSearching: false,
      loading: false,
      showFail: false,
      failMsg: null,
      search: null,
      itemsPerPageOptions: [10, 50],
      pageSize: 10,
      showTurtasSarasas: false,
      showConfirm: false,
      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmAction: null,
      modalConfirmItem: null,
      turtasSarasasAdresas: false,
      turtasSarasasRegistras: false,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    searchTurIdentifikatorius() {
      return (
        this.tur_identifikatorius ?? (this.isLocal ? '4193-9012-2010' : null)
      )
    },
    showIkeltiTurta() {
      return (
        this.isPrasymasSeima &&
        (this.isPrasymasPerkelimas || this.isPrasymasIsregistravimas) &&
        !this.yraTurtas &&
        !this.pageloading
      )
    },
    showPasalintiTurta() {
      return (
        (this.isPrasymasSeima && this.isPrasymasIregistravimas) ||
        (this.isPrasymasSeima && this.isPrasymasPerkelimas) ||
        this.isPrasymasBendra ||
        (this.isPrasymasNuoma && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPanauda && this.isPrasymasIregistravimas)
      )
    },
    showPagalAdresa() {
      return (
        (this.isPrasymasSeima && this.isPrasymasIregistravimas) ||
        (this.isPrasymasSeima && this.isPrasymasPerkelimas) ||
        (this.isPrasymasBendra && this.isPrasymasIregistravimas) ||
        (this.isPrasymasNuoma && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPanauda && this.isPrasymasIregistravimas)
      )
    },
    showPagalRegistra() {
      return (
        (this.isPrasymasSeima && this.isPrasymasIregistravimas) ||
        (this.isPrasymasSeima && this.isPrasymasPerkelimas) ||
        (this.isPrasymasBendra && this.isPrasymasIregistravimas) ||
        (this.isPrasymasNuoma && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPanauda && this.isPrasymasIregistravimas)
      )
    },
    showSearchForm() {
      return !this.isPrasymasIsregistravimas
    },
    yraTurtas() {
      return this.turtasLength > 0
    },
    showTurtasSearch() {
      return (
        !this.isPrasymasSeima ||
        (this.isPrasymasSeima && this.isPrasymasIregistravimas) ||
        (this.isPrasymasSeima && this.isPrasymasPerkelimas && this.yraTurtas) ||
        (this.isPrasymasSeima &&
          this.isPrasymasIsregistravimas &&
          this.yraTurtas)
      )
    },
  },
  created() {
    //
  },
  methods: {
    searchTurtas() {
      if (this.searchTurIdentifikatorius === null) {
        return false
      }
      this.loading = true
      this.showFail = false

      if (!this.validateTurIdentifikatorius()) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Įvestas neteisingas unikalus numeris, patikslinkite.'
        )
        this.loading = false
        return
      }

      const data = {
        tur_identifikatorius: this.searchTurIdentifikatorius,
        pra_turtas_teise: this.turtasTeise,
      }

      this.$axios
        .post(`ntrpaslaugos/prasymas/${this.prasymasID}/turtas/paieska`, data)
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    ikeltiTurtas() {
      this.loading = true
      this.showFail = false

      this.$axios
        .post(`ntrpaslaugos/prasymas/${this.prasymasID}/turtas/uzkrauti`)
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          // window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    pasalintiTurtas() {
      this.loading = true
      this.showFail = false

      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/turtas/pasalinti-ikeltus`
        )
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    adresasTurtas() {
      this.showFail = false
      this.turtasSarasasAdresas = true
      this.turtasSarasasRegistras = false
      this.showTurtasSarasas = true
    },
    registrasTurtas() {
      this.showFail = false
      this.turtasSarasasAdresas = false
      this.turtasSarasasRegistras = true
      this.showTurtasSarasas = true
    },
    validateTurIdentifikatorius() {
      const unikalus = this.searchTurIdentifikatorius
        .replaceAll('-', '')
        .replaceAll(':', '')
      return unikalus.length == 12 || unikalus.length == 16
    },
    cancelSearch() {
      this.tur_identifikatorius = null
      this.showFail = false
      this.$emit('cancelSearch')
    },
    updateTurtasList(failMsg = null) {
      this.tur_identifikatorius = null
      if (failMsg) {
        this.failMsg = failMsg
        this.showFail = true
      }
      this.$emit('updateTurtasList')
    },
    openConfirmIkeltiTurtas() {
      this.modalConfirmTitle = 'Įkelti nekilnojamajį turtą'
      this.modalConfirmText =
        'Ar tikrai norite įkelti viso savo nekilnojamojo turto duomenis?'

      this.modalConfirmAction = 'IkeltiTurtas'
      this.showConfirm = true
    },
    confirmIkeltiTurtas() {
      this.showConfirm = false
      this.ikeltiTurtas()
    },
    closeConfirm() {
      this.showConfirm = false
    },
  },
}
</script>
<style lang="scss" scoped>
.teise-label {
  display: inline;

  p {
    margin: 0;
  }
  p.teise-bold {
    font-weight: 600;
  }
}
</style>
